export const _set_initial_data = (payload) => ({
  type: "INIT",
  payload,
});

export const _remove_notification = (id) => ({
  type: "REMOVE_NOTIF",
  payload: id,
});

export const _set_seen = (id) => ({
  type: "SEEN",
  payload: id,
});

export const _add_notif = (notification) => ({
  type: "ADD_NOTIF",
  payload: notification,
});
